// extracted by mini-css-extract-plugin
export var formWrapper = "index-module--formWrapper--YJimj";
export var form = "index-module--form--Cip0V";
export var form__input_invalid = "index-module--form__input_invalid--pHZzD";
export var form__error_invalid = "index-module--form__error_invalid--FKYcu";
export var form__btn = "index-module--form__btn--6TSde";
export var formWrapper_isPopup = "index-module--formWrapper_isPopup--DPHMC";
export var closeBtn = "index-module--closeBtn--d7fGY";